import { defaultLogoUrl } from "../../../helpers/defaultUrls";
import { useFileStackContext } from "../../../hooks/useFileStackContext";

const MAX_LOGO_WIDTH = 570;
export const useLogoUrl = (logo?: string | null): string | null => {
  const { filestack } = useFileStackContext();

  if (logo && filestack) {
    return filestack.transform(logo, {
      resize: { width: MAX_LOGO_WIDTH },
      quality: { value: 80 },
    });
  }

  return defaultLogoUrl;
};
